<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-form
      ref="editMemberForm"
      v-model="editMemberFormValid"
      lazy-validation
    >
    <v-card class="mt-3 mb-4">
      <v-data-table
        :headers="headersMember"
        :items="members"
        class="elevation-1"
        hide-default-footer
        :items-per-page="-1"
        no-data-text="該当データがありません。"
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>メンバー編集</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="addMember" outlined color="primary"><v-icon left>mdi-account-multiple-plus</v-icon>メンバー追加</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.email="props">
        <v-text-field
          type="email"
          class="mt-4"
          v-model="props.item.email"
          outlined
          dense
          :rules="emailRules"
          :disabled="check(props.item.email)"
        ></v-text-field>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn :disabled="checkOwner(item)" outlined color="error" @click="removeMember(item)">削除</v-btn>
      </template>
      </v-data-table>
    </v-card>
    </v-form>
    <v-spacer></v-spacer>
    <div class="text-right">
      <v-btn class="primary" @click="confirmUpdate" width=165>保存</v-btn>
    </div>
    <add-mail-dialog
      v-model="addMailDialog"
      :mails="members"
    ></add-mail-dialog>
  </v-container>
</template>

<script>
import {store} from '@/store';
import AddMailDialog from '@/components/dialog/group/AddMailDialog.vue';
export default {
  name: "EditMember",
  components: {
    'add-mail-dialog': AddMailDialog,
  },

  data() {
    return {
      group_id: this.$route.params.groupId,
      editMemberFormValid: true,
      headersMember: [
        {
          text: 'メールアドレス',
          value: 'email',
          width: '70%',
        },
        {
          text: 'アクション',
          value: 'actions',
          width: '30%',
          align:'center',
        }
      ],
      loadingMember: true,
      members: [],
      original_members: [],
      addMailDialog: false,
      emailRules: [
        value => !!value || 'メルアドレスを入力してください.',
        value => value && value.length <= 50 || 'メールアドレスの長さは50文字以内にしてください。',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '有効なメールアドレスを入力してください。'
        }
      ],
      remove_members: [],
      add_members: [],
      owner: null,
      breadcrumbs: [
        {
            text: "グループ",
            disabled: false,
            exact: true,
            to: "/group"
        },
        {
            text: "",
            disabled: false,
            exact: true,
            to: "",
        },
        {
            text: "メンバー編集",
            disabled: false,
            exact: true,
        },
      ],

    }
  },

  methods: {
    arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    getMembers() {
      this.members = [];
      this.original_members = [];
      this.axios.get("/api/group/members/"+ this.group_id)
      .then((response) => {
        this.loadingMember = false;
        this.owner = response.data.email;
        this.members = response.data.members;
        const member_index =  this.members.findIndex(x => x.id == response.data.owner)
        this.arraymove(this.members, member_index, 0);
        this.original_members = JSON.parse(JSON.stringify(this.members));

        this.breadcrumbs[1].text = response.data.name;
        this.breadcrumbs[1].to = '/group/'+response.data.id;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
    checkOwner(item) {
      if(item.email == this.owner) {
        return true;
      }
      return false;
    },
    addMember() {
      this.addMailDialog = true;
    },
    removeMember(item) {
      const member_index =  this.members.findIndex(x => x.id == item.id)
      this.members.splice(member_index, 1);
      const status = this.original_members.find(x => x.email == item.email);
      if (status) {
        this.remove_members.push(item);
      }
    },
    check(mail) {
      const status = this.original_members.find(x => x.email == mail);
      return status ? true : false;
    },
    confirmUpdate() {
      if (this.$refs.editMemberForm.validate()) {
        const confirmDialog = {
          title: '編集確認',
          content: "グループのメンバーを編集します。よろしいですか。",
          onAgree: () => this.update(),
          onDisagree: null,
        };
        store.showConfirmDialog(confirmDialog);
      }
    },

    update() {
      this.add_members = [];
      if (this.$refs.editMemberForm.validate()) {
        for(var idx in this.members) {
          const existed_member = this.original_members.find(x => x.email == this.members[idx].email);
          if (!existed_member) {
            this.add_members.push(this.members[idx]);                
          }
        }
        store.showLoadingOverlay(true);
        this.axios.post("/api/group/members/"+ this.group_id + "/edit/", {'add_members': this.add_members, 'remove_members': this.remove_members})
        .then(() =>{
          store.showSuccessDialog("グループのメンバーが編集されました。");
          this.$router.push('/group/'+ this.group_id);
          this.remove_members = [];
        })
        .catch(()=>{
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        })
        .then(() => {
          store.showLoadingOverlay(false);
        });
      }
      
    }
  },
  created() {
    this.getMembers();
  },
}
</script>
<style scoped>
>>>.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row), .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) {
  border-bottom: none !important;
}
>>>.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  border-bottom: none !important;
}
</style>
